// Customizace Dashboardu: přesun karet mezi zónami (top / main / side), skrytí,
// obnovení výchozího rozložení. Ukládá se na server (DashboardLayout).
// Karty jsou v DOM vždy všechny; skryté leží v zásobníku [data-zone="hidden"].
import Sortable from 'sortablejs';

const ZONES = ['top', 'main', 'side'];
const DEFAULT_ZONE = { kpis: 'top', chart: 'main', news: 'main', fg: 'side', topics: 'side', calendar: 'side' };

function csrf() {
  const m = document.cookie.match(/(?:^|; )csrftoken=([^;]+)/);
  return m ? decodeURIComponent(m[1]) : '';
}

export function dashboard() {
  return {
    edit: false,
    names: {},
    hidden: [],
    sortables: [],

    init() {
      this.names = JSON.parse(document.getElementById('dash-names').textContent);
      this.hidden = this.read().hidden;
    },

    zone(name) { return this.$root.querySelector(`[data-zone="${name}"]`); },
    widget(key) { return this.$root.querySelector(`.widget[data-w="${key}"]`); },

    // Aktuální rozložení podle DOM
    read() {
      const out = { hidden: [] };
      for (const z of [...ZONES, 'hidden']) out[z] = [...this.zone(z).querySelectorAll(':scope > .widget')].map((w) => w.dataset.w);
      return out;
    },

    toggle() {
      this.edit = !this.edit;
      if (this.edit) {
        this.sortables = ZONES.map((z) => Sortable.create(this.zone(z), {
          group: 'dashboard', animation: 150, draggable: '.widget', handle: '.wtools',
          onEnd: () => this.changed(),
        }));
        this.syncSelects();
      } else {
        this.sortables.forEach((s) => s.destroy());
        this.sortables = [];
      }
    },

    move(key, dir) {
      const el = this.widget(key);
      const sib = dir < 0 ? el.previousElementSibling : el.nextElementSibling;
      if (!sib || !sib.classList.contains('widget')) return;
      dir < 0 ? sib.before(el) : sib.after(el);
      this.changed();
    },
    toZone(key, zone) { this.zone(zone).append(this.widget(key)); this.changed(); },
    hide(key) { this.zone('hidden').append(this.widget(key)); this.changed(); },
    show(key) { this.zone(DEFAULT_ZONE[key] || 'side').append(this.widget(key)); this.changed(); },

    reset() {
      const defaults = { top: ['kpis'], main: ['chart', 'news'], side: ['fg', 'topics', 'calendar'] };
      for (const z of ZONES) defaults[z].forEach((k) => this.zone(z).append(this.widget(k)));
      this.changed(true);
    },

    syncSelects() {
      for (const z of ZONES) this.zone(z).querySelectorAll(':scope > .widget').forEach((w) => {
        const sel = w.querySelector('.wsel'); if (sel) sel.value = z;
      });
    },

    async changed(reset = false) {
      const layout = this.read();
      this.hidden = layout.hidden;
      this.syncSelects();
      // Grafy se po přesunu přizpůsobí nové šířce sloupce
      window.dispatchEvent(new Event('resize'));
      try {
        await fetch(this.$root.dataset.saveUrl, {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'X-CSRFToken': csrf() },
          body: JSON.stringify(reset ? { reset: true } : { layout }),
        });
      } catch (err) {
        console.error('Dashboard layout was not saved', err);
      }
    },
  };
}
